// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableName_container__2fZKV","input":"EditableName_input__bwa9R","button":"EditableName_button__GDTWD","saveButton":"EditableName_saveButton__3fqOW"};